import { render, staticRenderFns } from "./StitchIcon.vue?vue&type=template&id=14fcb08b&scoped=true&"
import script from "./StitchIcon.vue?vue&type=script&lang=js&"
export * from "./StitchIcon.vue?vue&type=script&lang=js&"
import style0 from "./StitchIcon.vue?vue&type=style&index=0&id=14fcb08b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fcb08b",
  null
  
)

export default component.exports